var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardMinicardIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#4CD07A",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3013 17.4828C22.302 17.4828 24.7346 15.1248 24.7346 12.216C24.7346 9.30724 22.302 6.94922 19.3013 6.94922C16.3006 6.94922 13.868 9.30724 13.868 12.216C13.868 15.1248 16.3006 17.4828 19.3013 17.4828ZM19.3013 30.6498C24.5526 30.6498 28.8096 28.2918 28.8096 25.383C28.8096 22.4742 24.5526 20.1162 19.3013 20.1162C14.05 20.1162 9.79297 22.4742 9.79297 25.383C9.79297 28.2918 14.05 30.6498 19.3013 30.6498Z",
    fill: "#4CD07A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMinicardIcon1);
export default __webpack_public_path__ + "static/media/dashboard-minicard-icon1.5c03b415ede9891da0a0124c9f386856.svg";
export { ForwardRef as ReactComponent };